import React from 'react';
import ErrorPage from 'error/components/';
import { Provider } from 'react-redux';
import { renderToString } from 'react-dom/server';
import App from 'common/containers/app';
import { RouterContext } from 'react-router';

const Server404 = () => {
  const mockRouter = { location: { pathname: '404' } };
  return (<App>
    <ErrorPage router={mockRouter} />
  </App>);
};

const get404Html = (store, props) => (
  renderToString(<Provider store={store}>
    <RouterContext {...props} components={[Server404]} />
  </Provider>)
);

export default get404Html;



// WEBPACK FOOTER //
// ./error/components/404.jsx